module.exports = __webpack_public_path__ + "static/media/uniform-powerglove-512x512sat-brighter.3537e5da.jpg";